module.exports = __webpack_public_path__ + "img/logo.512c2089.png";